import { api } from '../../api/client'

/** Öffnet das PDF in einem neuen Tab — über fetch, weil der Aufruf ein Token braucht. */
export async function zeigePdf(id: number) {
  // Das Fenster sofort öffnen: Nach dem await sähe der Browser keinen Klick mehr und
  // blockierte es als Werbefenster.
  const fenster = window.open('', '_blank')
  const blob = await api.holeBlob(`/api/verkehrsmeldungen/${id}/datei`)
  const adresse = URL.createObjectURL(blob)
  if (fenster) fenster.location.href = adresse
  setTimeout(() => URL.revokeObjectURL(adresse), 60_000)
}

export function freigegeben(anzahl: number): string {
  if (anzahl === 0) {
    return 'Freigegeben. In den nächsten sieben Tagen ist niemand auf den betroffenen Linien eingeteilt — die Meldung erscheint am Dienst, sobald jemand eingeteilt wird.'
  }
  return `Freigegeben — ${anzahl} ${anzahl === 1 ? 'Fahrer hat' : 'Fahrer haben'} eine Nachricht bekommen.`
}

